import { render, staticRenderFns } from "./QuestionsurveyDetail2.vue?vue&type=template&id=134e1c01&scoped=true"
import script from "./QuestionsurveyDetail2.vue?vue&type=script&lang=js"
export * from "./QuestionsurveyDetail2.vue?vue&type=script&lang=js"
import style0 from "./QuestionsurveyDetail2.vue?vue&type=style&index=0&id=134e1c01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134e1c01",
  null
  
)

export default component.exports